module.exports = __webpack_public_path__ + "img/arrow_up.1f6de584.svg";